import util from '../util'

let controller = 'TemplateCAF'
export default Object.assign({}, util.GetCrud(controller, null))